import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import TripType from "../../components/TripType";
import VesselOperator from "../../components/VesselOperator";
import Spinner from "../../components/common/Spinner";
import DefaultButton from "../../components/DefaultButton";
import {
  getCurrentOpenTrip,
  getOperatorOptions,
} from "../../constants/vtrTrip";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { validateTripSet2 } from "../../constants/tripValidations";
import Grid from "@mui/material/Grid";
import { Navigate, useLocation } from "react-router-dom";

const success = "#5cb85c";

function VesselPermitOperatorPage(props) {
  const location = useLocation();
  const {
    auth,
    vtrTrip,
    helpText,
    validation: {
      validations: { tripType, operator = [] },
      loading,
    },
  } = useSelector((state) => state);

  const [trip_type, setTripType] = useState("");
  const [operator_permit_number, setOperatorPermitNumber] = useState("");
  const [operator_first_name, setOperatorFirstName] = useState("");
  const [operator_middle_name, setOperatorMiddleName] = useState("");
  const [operator_last_name, setOperatorLastName] = useState("");
  const [operator_ext_name, setOperatorExtName] = useState("");
  const [operator_options, setOperatorOptions] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [trip_type_set, setTripTypeSet] = useState(false);
  const values = {
    trip_type,
    operator_permit_number,
    operator_first_name,
    operator_middle_name,
    operator_last_name,
    operator_ext_name,
    operator_options,
  };

  const {
    vessel_entitlements,
    operator_entitlements,
    client_id,
    vtr_preferences,
  } = auth;

  useEffect(() => {
    if (loading === false) {
      const allOpentrips = vtrTrip.allOpenTrips;
      const currentTrip = getCurrentOpenTrip(
        allOpentrips,
        location.state.trip_id
      );
      if (currentTrip) {
        const operatorOptions = getOperatorOptions(
          operator,
          vessel_entitlements,
          operator_entitlements,
          auth,
          currentTrip.vessel_permit_num
        );
        setTripType(currentTrip.trip_type);
        setOperatorFirstName(currentTrip.operator_first_name);
        setOperatorMiddleName(currentTrip.operator_middle_name);
        setOperatorLastName(currentTrip.operator_last_name);
        setOperatorExtName(currentTrip.operator_ext_name);
        setOperatorPermitNumber(currentTrip.operator_permit_number);
        setOperatorOptions(operatorOptions);
        setTripTypeSet(currentTrip.trip_type === "" ? false : true);
        setIsLoaded(true);
      }
    }
  }, [
    loading,
    location.state.trip_id,
    operator,
    vessel_entitlements,
    operator_entitlements,
    vtrTrip,
    auth,
  ]);

  const handleTripTypeChange = (event) => {
    setTripType(event.target.value);
  };

  const handleTripTypePreferenceChange = (event) => {
    event.preventDefault();
    let newTripType = event.currentTarget.dataset.newValue;
    console.log(newTripType);
    setTripType(event.target.value);
  };

  const handleTripOperatorPreferenceChange = (event) => {
    event.preventDefault();
    let { operatorKey, nameFirst, nameMiddle, nameLast, nameExt, field } =
      event.currentTarget.dataset;

    if (!operatorKey) {
      console.log("No vessel operator value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }

    setOperatorPermitNumber(operatorKey);
    setOperatorFirstName(nameFirst);
    setOperatorMiddleName(nameMiddle);
    setOperatorLastName(nameLast);
    setOperatorExtName(nameExt);
    console.info(
      "prefOperatorchange",
      operator_permit_number,
      operator_first_name,
      operator_middle_name,
      operator_last_name,
      operator_ext_name
    );
  };

  const handleOperatorChange = (event, reason) => {
    event.preventDefault();
    if (reason) {
      if (
        reason.hasOwnProperty("OPERATOR_KEY") &&
        reason.hasOwnProperty("NAME_FIRST") &&
        reason.hasOwnProperty("NAME_MIDDLE") &&
        reason.hasOwnProperty("NAME_LAST")
      ) {
        setOperatorPermitNumber(reason.OPERATOR_KEY);
        setOperatorFirstName(reason.NAME_FIRST);
        setOperatorMiddleName(reason.NAME_MIDDLE);
        setOperatorLastName(reason.NAME_LAST);
        if (reason.hasOwnProperty("NAME_EXT")) {
          setOperatorExtName(reason.NAME_EXT);
        }
      }
    } else {
      setOperatorPermitNumber("");
      setOperatorFirstName("");
      setOperatorMiddleName("");
      setOperatorLastName("");
    }
  };

  const _cancel = (event, value) => {
    event.preventDefault();
    let errors = [];
    const { actions } = props;
    actions.setError(errors);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    const { actions } = props;
    let errors = validateTripSet2(values);
    actions.setError(errors);
    if (errors.length > 0) {
      console.error("VesselPermitOperatorPage", errors);
      return;
    }
    if (value === "Save") {
      actions.updateTrip(values, client_id, location.state.trip_id);
    }
  };

  if (vtrTrip.redirect === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
        state={{
          trip_id: location.state.trip_id,
          client_id: client_id,
        }}
      />
    );
  }

  if (isLoaded === false || loading === true) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  return (
    <div className="trip-form-container">
      {!trip_type_set && (
        <TripType
          trip_type={trip_type}
          handleChange={handleTripTypeChange}
          tripTypes={tripType}
          preferences={vtr_preferences.trip}
          handleTripTypePreferenceChange={handleTripTypePreferenceChange}
          helpText={helpText.helpText}
        />
      )}
      <VesselOperator
        changeHandler={handleOperatorChange}
        operatorOptions={operator_options}
        operator_permit_number={operator_permit_number}
        operator_first_name={operator_first_name}
        operator_middle_name={operator_middle_name}
        operator_last_name={operator_last_name}
        operator_ext_name={operator_ext_name}
        handleTripOperatorPreferenceChange={handleTripOperatorPreferenceChange}
        preferences={vtr_preferences.operator}
        helpText={helpText.helpText}
      />
      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(
  mapVtrStateToProps,
  mapDispatchToProps
)(VesselPermitOperatorPage);
